<template>
  <div>
    <v-card class="rounded-lg"> 
          <v-row class="pa-6 space" dense>
            <v-col cols="12" sm="auto">
              <PatientFilter @resource="handleFilterResource" />
             </v-col>
 
             <v-col cols="12" sm="auto">
              <v-btn 
                class="rounded-lg new-patient-btn" 
                elevation="1" 
                color="#2a6334" 
                block
                @click="goToNewPatient()"
                v-if="permissionsToNewPatient"
              >
                <v-icon style="color: white">mdi-plus</v-icon>
                <span class="textBtn">{{$t('buttons.new_patient')}}</span>
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="donor"
            :footer-props="{ 'items-per-page-text': 'Pacientes por página' }"
            :page="page"
            :loading="loading"
          >
            <template #no-data>
              <div class="text-center py-4">Nenhum paciente encontrado</div>
            </template>

            <template v-slot:[`item.name`]="{ item }">
              <span>{{
                typeof item.name === "string" && item.name.trim()
                  ? item.name
                  : "Paciente não Identificado"
              }}</span>
            </template>

            <template v-slot:item.cpf="{ item }">
              <span>{{ formatCpf(item.cpf) }}</span>
            </template>

            <template v-slot:item.situation="{ item }">
              <v-chip :color="item.kind_of_donor.name == 'ME' ? '#a7f3d0' : '#d1fae5'">
                <v-icon class="mr-2" small>{{ item.kind_of_donor.name == 'ME' ? 'mdi-brain' : 'mdi-heart-pulse' }}</v-icon>{{ item.kind_of_donor.name}}</v-chip>
            </template>

            <template v-slot:item.date="{ item }">
              <v-chip color="#E9F2EC"><v-icon class="mr-2" small>mdi-calendar</v-icon>{{ formatHoraDataBr(item.created_at) }}</v-chip>
            </template>

            <template v-slot:item.last_update="{ item }">
              <v-chip color="#f5eed3"><v-icon class="mr-2" color="#262625" small>mdi-calendar-clock</v-icon>{{ formatHoraDataBr(item.updated_at) }}</v-chip>
            </template>

            <template v-slot:[`item.opo_or_opc`]="{ item }">
              <span
                v-if="item.unities.opo_reference || item.unities.opc_reference"
              >
                {{
                  item.kind_of_donor.name == "ME"
                    ? item.unities.opo_reference.description
                    : item.unities.opc_reference.description
                }}
              </span>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <PatientStatusChip
                :name="item.donor_status.name"
                :color="getStatusConfig(item.donor_status.slug).color"
                :icon="getStatusConfig(item.donor_status.slug).icon"
                :tooltip-text="
                  isPatientInapto(item) ? reasonAssessmentText(item) : null
                "
              />
            </template>

            <template v-slot:[`item.medical_records`]="{ item }">
              <span>{{
                item.medical_records ? item.medical_records : "Não Informado"
              }}</span>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu left :offset-x="true">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    data-cy="menu-acoes"
                    size="24"
                    class="icon"
                    color="#41916b"
                    align-item="center"
                    v-on="on"
                    v-bind="attrs"
                    >mdi-cog
                  </v-icon>
                </template>
                <v-list dense class="rounded-lg">
                  <div class="text-center py-2 font-bold">
                    <span>Menu de Ações</span>
                  </div>
                  <v-list-item
                    
                    v-for="(menuItem, index) in getMenuItems(item)"
                    class="hover-grey"
                    :key="index"
                    :disabled="menuItem.disabled"
                    @click="
                      menuItem.click
                        ? menuItem.click(item)
                        : setItem(item, menuItem)
                    "
                  >
                    <v-icon class="mr-2" :color="menuItem.color">{{
                      menuItem.icon
                    }}</v-icon>
                    <v-list-item-title
                      v-html="menuItem.title"
                    ></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>

          <v-dialog v-model="dialog" persistent width="600">
            <v-card>
              <EndingPme
                v-if="type_dialog == 'ending_pme'"
                :resource="resource"
                @closeDialog="dialog = false"
                @updateGrid="loadGridData()"
              />
              <AdmControl
                v-else
                :resource="resource"
                @closeDialog="dialog = false"
                @updateGrid="loadGridData()"
              />
            </v-card>
          </v-dialog>

          <v-overlay :value="loadingPDF">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay> 
    </v-card>
  </div>
</template>
<script>
import axios from "@/axios";
import { mapActions } from "vuex";
import PatientFilter from "./PatientGridFilter-comp.vue";
import PatientStatusChip from "./PatientStatusChip-comp.vue";
import FormFieldsService from "@/service/FormFieldsService";
import EndingPme from "./ending-pme/EndingPme";
import { getMenuItemsByDonor } from "@/helpers/donorMenuHelper";
import { getStatusConfig } from "@/helpers/statusHelper";
import Formatters from "@/utils/Formatters";
import currentUser from "@/utils/currentUser";
import { profileSlug } from "@/helpers/profileSlug";
import AdmControl from "@/components/pacientes/adm-control/AdmControl";
export default {
  data() {
    return {
      headers: [
        { text: "Status", align: "center", value: "status" },
        { text: "Situação", align: "center", value: "situation" },
        { text: "Nome do Paciente", align: "center", value: "name" },
        { text: "CPF", align: "center", value: "cpf" },

        { text: "OPO/OPC", value: "opo_or_opc", align: "center" },
        {
          text: "Hospital Notificante",
          value: "unities.hospital",
          align: "center",
        },
        {
          text: "Número do Prontuário",
          align: "center",
          value: "medical_records",
        },
        { text: "Data/Hora de Entrada", align: "center", value: "date" }, 
        { text: "Última Atualização (por status)", align: "center", value: "last_update" }, 

        { text: "Ações", value: "actions", align: "center", sortable: false },
      ],
      page: 1,
      loading: false,
      options: {},
      sortBy: "name",
      donor: [],
      loadingPDF: false,
      dialog: false,
      type_dialog: "",
      resource: {},
    };
  },

  watch: {
    options: {
      handler() {
        this.loadGridData();
      },
      deep: true,
    },
  },

  computed: {
    currentUser() {
      return currentUser.getUserData();
    },

    permissionsToNewPatient() {
      return this.currentUser.abilities?.includes("cad_donor");
    },

    isADM() {
      return [
        "admin",
        "diretor",
        "plantonista_cet_coset",
        "sesab_coset",
        "tec_central",
      ].includes(this.profile);
    },

    profile() {
      return profileSlug(this.currentUser.profile);
    },

    showAllUnities() {
      return this.currentUser.abilities?.includes("list_all_unities");
    },
  },

  methods: {
    ...mapActions([
      "changePatientData",
      "changeClinicalReportsData",
      "changePCRDeathData",
      "changeCaptationData",
      "changeDonorId",
      "changeForPCRPatientData",
      "changeOrgonsCaptureds",
      "changeSnackBarData",
      "changeClinicalHistories",
      "changeMEClinicalHistories",
      "changeMacroscopicData"
    ]), 
    goToNewPatient() {
      this.changePatientData({});
      this.$router.push("/cadastrar-paciente");
    },

    isPatientInapto(item) {
      const unfit_status = item && item.donor_status;

      return (
        unfit_status &&
        (unfit_status.slug === "pct-inapto" ||
          unfit_status.slug === "doacao-nao-aut" ||
          unfit_status.slug === "finalizado-sem-entrevista-familiar")
      );
    },

    reasonAssessmentText(item) {
      const status = item && item.donor_status && item.donor_status.slug;
      if (status === "doacao-nao-aut") {
        const justification =
          item.family_authorization && item.family_authorization.justification;
        const options =
          item.family_authorization &&
          item.family_authorization.family_authorization_options;
        const option = options && options[0] && options[0].authorization_option;

        return (
          justification ||
          (option ? option.description : "Motivo Não Encontrado")
        );
      }

      if (status === "finalizado-sem-entrevista-familiar") {
        const hasInterview =
          item.family_interviews &&
          item.family_interviews[0].reason_interview.description;
        const interviewDescription = hasInterview
          ? item.family_interviews[0].reason_interview.description
          : null;

        return interviewDescription ?? "Motivo Não Encontrado";
      }

      const assessment = item && item.initial_assessment;
      const justification = assessment && assessment.justification;

      const reason = justification
        ? assessment.justification
        : assessment.reason_assessment
        ? assessment.reason_assessment.description
        : null;

      return reason || "Motivo Não Encontrado";
    },

    getMenuItems(item) {
      return getMenuItemsByDonor({
        item,
        profile: this.currentUser.slug_profile,
        opoProfile: this.currentUser.profile,
        getPDF: this.getPDF,
      });
    },

    handleFilterResource(data) {
      this.donor = data;
      this.loading = false;
    },

    async loadGridData() {
      this.loading = true;
      let items = {};
      let unity_id = "";

      if (!this.showAllUnities) {
        unity_id = this.$store.state.unity_id;
      }

      if (["plantonista_opc"].includes(this.profile)) {
        items = {
          kind_of_donor: 2,
        };
      }

      this.donor = await FormFieldsService.getPatientsData(items, unity_id);
      this.loading = false;
    },

    formatCpf: Formatters.formatCpf,
    formatHoraDataBr: Formatters.formatHoraDataBr,

    setItem(item, menuItem) {
      switch (menuItem.path) {
        case "/informes-clinicos":
          this.changeClinicalReportsData(item.clinical_report[0]);

          if (item.clinical_histories) {
            this.changeMEClinicalHistories(item.clinical_histories[0]);
          }
          break;

        case "/dados-morte":
          this.changePCRDeathData(item.pcr_donor_data);
          this.changeDonorId(item.id);
          break;

        case "/cadastrar-captacao":
          if (item.captation) {
            this.changeCaptationData(item.captation);
          } else {
            localStorage.setItem("orgonsCaptured", JSON.stringify(item));
            this.changeCaptationData(null);
          }

          if (item.clinical_histories) {
            this.changeClinicalHistories(item.clinical_histories[0]);
          }

          if (item.macroscopic_pcr_donor) {
            this.changeMacroscopicData(item.macroscopic_pcr_donor);
          }

          this.changeForPCRPatientData(item.pcr_donor_data);
          break;

        case "/orgaos-captados":
          if (item.captation) {
            this.changeOrgonsCaptureds(item.captation.orgons_captured);
          }
          this.changeForPCRPatientData(item.pcr_donor_data);
          break;

        case "/ending_pme":
          this.dialog = true;
          this.type_dialog = "ending_pme";
          this.resource = item.encerramento_pme[0];
          break;

        case "/adm-control":
          this.dialog = true;
          this.type_dialog = "adm-control";
          this.resource = item;
          break;

        default:
          break;
      }

      this.changePatientData(item);
      if (menuItem.path != "/ending_pme" && menuItem.path != "/adm-control") {
        this.$router.push({ path: menuItem.path, query: { item: item } });
      }
    },

    getPDF(item) {
      this.loadingPDF = true;

      axios
        .get(`/donor/pdf_general/${item.id}`, {
          responseType: "blob",
        })
        .then((response) => {
          this.loadingPDF = false;
          let url = window.URL.createObjectURL(new Blob([response.data]));
          let link = document.createElement("a");
          link.href = url;
          let nome = (item.name || "paciente").trim().replace(/\s+/g, "_");
          link.setAttribute("download", `historico_${nome}.pdf`);

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.loadingPDF = false;
          this.changeSnackBarData({
            status: true,
            type: "erro",
            titleMessage: "Algo deu errado!",
            bodyMessage: error.details,
            cardColor: "red",
            titleIcon: "mdi-close-circle",
          });

          setTimeout(() => {
            this.changeSnackBarData({
              status: false,
              type: "",
              titleMessage: "",
              bodyMessage: "",
              cardColor: "",
              titleIcon: "",
            });
          }, 5000);
        });
    },

    getStatusConfig,
  },

  mounted() {
    if (sessionStorage.getItem("donorSearchFilter")) {
      this.loading = true;
    } else {
      this.loadGridData();
    }
  },

  components: {
    PatientFilter,
    PatientStatusChip,
    EndingPme,
    AdmControl,
  },
};
</script>
<style scoped>
.d-flex {
  padding: 0 6px 0 0;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 40px !important;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

.new-patient-btn:hover {
  background-color: #88beaa !important;
  transition: 0.2s;
}

.space {
  width: 5px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.hover-grey:hover {
  background-color: #f0fff4 !important;
  cursor: pointer;
}
</style>
